import { transformErrorResponse } from "../../transformErrorResponse"
import { FilesDocDTO, Peru9112WinENTITY } from "sigo-entities"
import { AtcApiBuilder } from "."

export const PERU_9112_WINOrder = (build: AtcApiBuilder) => {
    return {
        getByIdWINOrders: build.query<Peru9112WinENTITY[], string>({
            query: (userId) => `procesos/PERU_9112_WINOrder/${userId}`,
            providesTags: (result, error, userId) =>
                result
                    ? [
                        // tag individual por cada orden
                        ...result.map((order) => ({
                            type: 'WINOrders' as const,
                            id: order._id,
                        })),
                        // y un tag general de la lista de ese usuario
                        { type: 'WINOrders' as const, id: `USER-${userId}` },
                    ]
                    : [{ type: 'WINOrders' as const, id: `USER-${userId}` }],
            transformErrorResponse
        }),
        getTransitWINOrders: build.query<{ transito: number }, { id_recurso: string, codigo: number }>({
            query: ({ id_recurso, codigo }) => `procesos/PERU_9112_WinOrder/calculate-transit/${id_recurso}/${codigo}`,
            transformErrorResponse
        }),
        addInventoryWINOrders: build.mutation<Peru9112WinENTITY, { id: string, body: { ID_StockPersonal: number, cantidad: number, Serie?: { Serie: string, ID_StockPersonalEquipos: number } } }>({
            query: ({ body, id }) => ({
                url: `procesos/PERU_9112_WinOrder/add-inventory/${id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'WINOrders' as const, id },
            ],
            transformErrorResponse
        }),
        deleteInventoryWINOrders: build.mutation<Peru9112WinENTITY, { id: string, codigo: number, serie: string }>({
            query: ({ id, codigo, serie }) => ({
                url: `procesos/PERU_9112_WinOrder/delete-inventory/${id}/${codigo}?serie=${serie}`,
                method: "PUT",
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'WINOrders' as const, id },
            ],
            transformErrorResponse
        }),
        finalizeWINOrders: build.mutation<Peru9112WinENTITY, { id: string }>({
            query: ({ id }) => ({
                url: `procesos/PERU_9112_WinOrder/finalize/${id}`,
                method: "PUT"
            }),
            invalidatesTags: (result, error, { id }) => [
                // invalida la orden puntual
                { type: 'WINOrders' as const, id },
                // y también la lista del usuario (para que se refresque)
                // { type: 'WINOrders' as const, id: `USER-${userId}` },
            ],
            transformErrorResponse
        }),
        uploadPhotosWINOrders: build.mutation<Peru9112WinENTITY, { id: string, boletin: FilesDocDTO }>({
            query: ({ boletin, id }) => ({
                url: `procesos/PERU_9112_WinOrder/upload-files/${id}`,
                method: "PUT",
                body: { boletin },
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'WINOrders' as const, id },
            ],
            transformErrorResponse
        }),
    }
}